import './styles.scss'
import { React, useEffect, useState } from 'react'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import { useTranslation } from 'react-i18next'
import { commonMethods, useResizeHandler } from 'Utils/commonMethods'

const AccordionHistoryData = ({ isDialogModalOpen, handleCloseModal, freightRateHistoryData, portHeaderData }) => {
  const { t } = useTranslation()

  const { isWebView } = useResizeHandler()

  const [currentSlideData, setCurrentSlideData] = useState(null)

  const { dateFormatBasedOnUser } = commonMethods

  useEffect(() => {
    setCurrentSlideData(freightRateHistoryData?.returnLst)
  }, [freightRateHistoryData])

  useEffect(() => {
    document.body.style.overflow = isDialogModalOpen ? 'hidden' : ''

    return () => {
      document.body.style.overflow = ''
    }
  }, [isDialogModalOpen])

  const freightRatesHistoryData = () => (
    <div className="accordion-history-data-row">
      <table>
        <thead>
          <tr>
            <th colSpan={4}>
              <img className="image-flag" src={currentSlideData?.loadPortIso3 ? `https://coffeeweb.s3.ap-south-1.amazonaws.com/Masters/Flags/${currentSlideData?.loadPortIso3}.svg` : ''} alt={currentSlideData?.loadPortIso3} /> {t('LOADING_PORTS')} : {portHeaderData?.loadingPort}
            </th>
            <th colSpan={3}>
              {t('DESTINATION_PORTS')} : {portHeaderData?.destinationPort} <img className="image-flag" src={currentSlideData?.destinationPortIso3 ? `https://coffeeweb.s3.ap-south-1.amazonaws.com/Masters/Flags/${currentSlideData?.destinationPortIso3}.svg` : ''} alt={currentSlideData?.destinationPortIso3} />
            </th>{' '}
          </tr>
          <tr>
            <th>{t('MONTH')}</th>
            <th>{t('TERMINAL_LEVEL')}</th>
            <th colSpan={2}>{t('BETWEEN')}</th>
            <th>{t('TRANSIT_PERIOD')}</th>
            <th>{t('REMARKS')}</th>
          </tr>
        </thead>

        <tbody>
          {currentSlideData?.data?.map((item, index) => {
            const isFirstRow = index === 0
            const totalRows = currentSlideData?.data?.length || 1

            return (
              <tr key={index}>
                <td>{item?.fullMonthYear ? item?.fullMonthYear : '--'}</td>
                <td>{item?.terminalLevel ? item?.terminalLevel : '--'}</td>
                <td className="between-td">{item?.freightRateFrom ? item?.freightRateFrom : '--'}</td>
                <td className="between-td">{item?.freightRateTo ? item?.freightRateTo : '--'}</td>
                <td className="transit-period">{portHeaderData?.transitPeriod ? portHeaderData?.transitPeriod : '--'}</td>
                {isFirstRow && <td rowSpan={totalRows}>{portHeaderData?.others ? portHeaderData?.others : '--'}</td>}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )

  return <DialogUIModal title={currentSlideData?.label || t('PREVIOUS_DATA')} titlePosition="center" size="lg" showModal={isDialogModalOpen} bodyContent={freightRatesHistoryData} handleClose={() => handleCloseModal()} testId="accordion-popup" />
}

export default AccordionHistoryData
